
/* injects from baggage-loader */
require('./style.scss');

import React, { useState, useMemo } from "react";
import CMSApi from "../../../services/cmsApi";
import { useDataFetch } from "../customHooks/dataFetch";
import Loader from "../../components/loader";
import LiveCasinoProviders from "./components/providers";
import LiveCasinoGamesWrapper from "./components/gamesWrapper";
import _ from "lodash";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { OpenPopup } from "../../../actions/ui";
import { HandleLotteryGame } from "../../../helpers/casino/helpers";
import Config from "../../../config/main";

const LiveCasino = ({ user, dispatch }) => {
	const [data, loading] = useDataFetch(() => CMSApi.getLiveCasinoGames({ count: "all" }), []);
	const [selectedProvider, setSelectedProvider] = useState(null);
	const [offset, setOffset] = useState(0);
	const limit = Config.liveCasino.games.loaderStep;

	const providers = useMemo(() => {
		if (!data?.games) return [];
		const allList = data.games.map(item => _.pick(item, "provider_title", "provider"));
		return _.uniqBy(allList, "provider");
	}, [data]);

	const gameList = useMemo(() => {
		if (!selectedProvider) return data?.games;
		return data?.games.filter(item => item.provider === selectedProvider);
	}, [data, selectedProvider]);

	const onSelectProvider = provider => {
		setSelectedProvider(provider);
		setOffset(0);
	};

	const openGame = (game /* studioId, forceToOpen */) => {
		return () => {
			// if (!user.reallyLoggedIn && !forceToOpen) { //eslint-disable-line react/prop-types
			//     this.bufferedAction = {
			//         game,
			//         studioId
			//     };
			// }
			//!TODO CMS discuss why (bufferedAction)
			const gameUrl = HandleLotteryGame(user, game.extearnal_game_id);
			dispatch(OpenPopup("iframe", { iframeUrl: gameUrl, id: game.extearnal_game_id }));
		};
	};

	const pagination = newOffset => {
		if (newOffset < offset && offset === 0) return;
		else if (newOffset >= gameList.length) return;

		setOffset(newOffset);
	};

	if (loading) return <Loader component="liveCasinoo" />;

	return (
		<div className="livecasino-wrapper">
			<LiveCasinoProviders
				selected={selectedProvider}
				providers={providers}
				onChange={onSelectProvider}
			/>

			{gameList && (
				<LiveCasinoGamesWrapper
					games={gameList.slice(offset, offset + limit)}
					openGame={openGame}
					key={selectedProvider}
				/>
			)}

			<div className="slider-arrow-t">
				<div className="left-arrow-t" onClick={() => pagination(offset - limit)}>
					<i className="icon-s-t" />
				</div>
				<div className="right-arrow-t" onClick={() => pagination(offset + limit)}>
					<i className="icon-s-t" />
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = _ => {
	return createSelector([state => state.user], user => ({ user }));
};

export default connect(mapStateToProps)(LiveCasino);
